import { deviceInfoModel } from '@/models/authentication/deviceInfo.model';

export const common = {
	handleResponse,
	handleResponse2,
	getDevideInfo,
	randomString
};

async function handleResponse(response) {
    try {
        return await response.text().then((text) => {
            if (!response.ok) {
                throw new Error('Lỗi khi gọi API', {
                    cause: { response },
                });
            }
            else {
                const data = JSON.parse(text);
                return data;
            }
        });
    }
    catch (error) {
        let message = error;
        switch (error.cause.response?.status) {
            case 400:
                message = 'Yêu cầu không hợp lệ';
                break;
            case 401:
                message = 'Phiên đăng nhập hết hạn';
                break;
            case 403:
                message = 'Không có quyền truy cập';
                break;
            case 404:
                message = 'Không tìm thấy yêu cầu';
                break;
            case 429:
                message = 'Quá nhiều yêu cầu trong khoảng thời gian cho phép';
                break;
            case 500:
                message = 'Máy chủ gặp lỗi';
            break;
        }
        return { statusCode: 400, message: message };
    }
}


function handleResponse2(response) {
    try {
        return response.text().then((text) => {
            if (!response.ok) {
                throw new Error('Lỗi khi gọi API', {
                    cause: { response },
                });
            }
            else {
                const data = JSON.parse(text);
                return Promise.resolve(data);
            }
        });
    }
    catch (error) {
        let message = error;
        switch (error.cause.response?.status) {
            case 400:
                message = 'Yêu cầu không hợp lệ';
                break;
            case 401:
                message = 'Phiên đăng nhập hết hạn';
                break;
            case 403:
                message = 'Không có quyền truy cập';
                break;
            case 404:
                message = 'Không tìm thấy yêu cầu';
                break;
            case 429:
                message = 'Quá nhiều yêu cầu trong khoảng thời gian cho phép';
                break;
            case 500:
                message = 'Máy chủ gặp lỗi';
            break;
        }
        return Promise.reject({ statusCode: 400, message: message });
    }
}

async function getDevideInfo() {
    let deviceInfo = deviceInfoModel.newModel();
    let userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = null;
    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS';
    }
    else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS';
    }
    else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows';
    }
    else if (/Android/.test(userAgent)) {
        os = 'Android';
    }
    else if (!os && /Linux/.test(platform)) {
        os = 'Linux';
    }
    deviceInfo.deviceOs = os;
    let ua = navigator.userAgent;
    let tem;
    let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE ' + (tem[1] || '');
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    deviceInfo.browser = M.join(' ');
    return deviceInfo;
}

function randomString(length) {
	let result = '';
	const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	const charactersLength = characters.length;
	let counter = 0;
	while (counter < length) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
		counter += 1;
	}
	return result;
}